import { c as _c } from "react/compiler-runtime";
import { CircularProgress, FontWeights, Tab, Tabs, Text } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
/** Name of a tab, followed by a badge with the number of its items and a spinner while busy */
function TabLabelWithStatus(t0) {
  const $ = _c(10);
  const {
    label,
    count,
    isBusy
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== count) {
    t2 = !!count && <Text variant="bodyS" component="var" sx={{
      minWidth: "1.25rem",
      height: "1.25rem",
      px: 0.75,
      borderRadius: "0.625rem",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "primary.main",
      color: "primary.contrastText",
      fontSize: "0.75rem",
      fontWeight: FontWeights.SemiBold,
      fontStyle: "normal"
    }}>{count}</Text>;
    $[1] = count;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isBusy || $[4] !== label) {
    t3 = isBusy && <CircularProgress size="0.875rem" aria-label={`Updating ${label.toLowerCase()}`} />;
    $[3] = isBusy;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label || $[7] !== t2 || $[8] !== t3) {
    t4 = <Stack direction="row" sx={t1}>{label}{t2}{t3}</Stack>;
    $[6] = label;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
/**
 * Component that renders tabs with dynamic content based on the selected tab.
 *
 * This component renders tabs based on the provided `tabs` array, allowing users
 * to switch between different tab content. It utilizes the `handleChange` function
 * to update the selected tab when a tab is clicked.
 *
 * @returns JSX.Element
 */
export function SidePanelTabs(t0) {
  const $ = _c(6);
  const {
    tabs,
    selectedTab,
    handleChange
  } = t0;
  let t1;
  if ($[0] !== tabs) {
    t1 = tabs.map(_temp);
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleChange || $[3] !== selectedTab || $[4] !== t1) {
    t2 = <Box><Tabs value={selectedTab} onChange={handleChange} aria-label="Choose a tab">{t1}</Tabs></Box>;
    $[2] = handleChange;
    $[3] = selectedTab;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(tab) {
  return <Tab key={tab.label} value={tab.label} disabled={tab.isDisabled ?? false} draggable={false} label={tab.count || tab.isBusy ? <TabLabelWithStatus label={tab.label} count={tab.count} isBusy={tab.isBusy} /> : tab.label} />;
}